'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('userRequestEditControllers')

.factory('editAccessRequestService', ['$http', '$q', function ($http, $q) {

    var service = {};
    service.sameAs = {};
    service.systemRolePendings = {};
    service.request = {};

    // **** Models
    service.mergePendingsAndExistingsRoles = function (pendings, existings) {
        var existingsDict = _.groupBy(existings, 'SystemRoleID');

        _.forEach(pendings, function (pending) {

            // but remove 'to add' pendings
            if (pending.ToAdd === true) {
                delete existingsDict[pending.SystemRoleID];
            }

            // and add 'to remove' pendings
            else if (_.isUndefined(existingsDict[pending.SystemRoleID])) {
                existingsDict[pending.SystemRoleID] = pending;
            }

            else {
                if (!_.isUndefined(existingsDict[pending.SystemRoleID][0])) {
                    existingsDict[pending.SystemRoleID][0].ToAdd = pending.ToAdd;
                    existingsDict[pending.SystemRoleID][0].ToRemove = pending.ToRemove;
                    existingsDict[pending.SystemRoleID][0].ToKeep = pending.ToKeep;
                }
                existingsDict[pending.SystemRoleID].ToAdd = pending.ToAdd;
                existingsDict[pending.SystemRoleID].ToRemove = pending.ToRemove;
                existingsDict[pending.SystemRoleID].ToKeep = pending.ToKeep;
            }
        });
        var existings = Object.keys(existingsDict).map(function (key) {
            var propValue = existingsDict[key];
            if (!_.isUndefined(propValue[0])) return propValue[0];
            return propValue;
        });

        return existings;
    }

    // **** HttpPost

    // Request
    var baseUrlRequestId = function (userAccessRequestId) {
        return environment.apiUrl + '/ID/API/UserRequest/' + userAccessRequestId;
    }

    service.request.cancel = function (userAccessRequestId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/Cancel', {});
    }

    service.request.specialSubmit = function (userAccessRequestId, skipSupervisorAuthorization, skipSystemOwnerAuthorization) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SpecialSubmit', {
            skipSupervisorAuthorization,
            skipSystemOwnerAuthorization
        });
    }

    service.request.manualSupervisorApprovalSubmit = function (userAccessRequestId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/ManualSupervisorApprovalSubmit', {});
    }

    service.request.submit = function (userAccessRequestId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/Submit', {});
    }

    service.request.modify = function (userAccessRequestId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/Modify', {});
    }

    service.request.updateInfos = function (userAccessRequestId, comments, dontProcessBefore, adminTicketNumber) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/UpdateInfos', {
            Comments: comments,
            DontProcessBefore: dontProcessBefore,
            AdminTicketNumber: adminTicketNumber
        });
    }

    service.request.addSystemAccount = function (userAccessRequestId, systemId, systemAccount) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/AddSystemAccount', {
            SystemID: systemId,
            SystemAccount: systemAccount
        });
    }

    service.request.validationMessages = function (userAccessRequestId, checkSystemAccounts) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/ValidationMessages', {
                        checkSystemAccounts: checkSystemAccounts
                    })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.request.events = function (userAccessRequestId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/Events', {})
                    .then(function (response) {
                        return response.data;
                    });
	}

	// Get Proposed ADM Account Login
    service.request.getProposedActiveDirectoryAdmAccountUsername = function (userAccessRequestId) {
		return $http
			.get(baseUrlRequestId(userAccessRequestId) + '/AdmLogin/Proposed')
			.then(function (response) { return response.data; });
	}

    // Check Correct ADM Account
    service.request.checkCorrectAdmAccount = function (userAccessRequestId, loginName) {
        return $http
            .post(baseUrlRequestId(userAccessRequestId) + '/AdmLogin/CheckCorrect', {
                LoginName: loginName,
            })
            .then(function (response) { return response.data; });
    }

    // Add ADM Account
    service.request.addAdmAccountToUserRequest = function (userAccessRequestId, loginName) {
        return $http
            .post(baseUrlRequestId(userAccessRequestId) +
                '/AdmLogin', { LoginName: loginName })
            .then(function (response) { return response.data; });
    }

    // Same AS
    service.sameAs.searchEmployees = function (userAccessRequestId, searchTerm) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SameAs/SearchEmployees', {
                        searchTerm: searchTerm
                    })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.sameAs.getSystemRolesByEmployee = function (userAccessRequestId, sameAsEmployeeId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) +
                          '/SameAs/SystemRolesByEmployee/' + sameAsEmployeeId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.sameAs.copyAllSystemRoles = function (userAccessRequestId, sameAsEmployeeId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) +
                          '/SameAs/SystemRolesByEmployee/' + sameAsEmployeeId + '/CopyAll', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // System Role Pendings
    service.systemRolePendings.preAdd = function (userAccessRequestId, systemRoleId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRolePending/PreAdd',
                          {
                              SystemRoleID: systemRoleId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.systemRolePendings.preClose = function (userAccessRequestId, systemRoleId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRolePending/PreClose',
                          {
                              SystemRoleID: systemRoleId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.systemRolePendings.delete = function (userAccessRequestId, systemRoleId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRolePending/Delete',
                          {
                              SystemRoleID: systemRoleId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.systemRolePendings.keep = function (userAccessRequestId, systemRoleId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRolePending/Keep',
                          {
                              SystemRoleID: systemRoleId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.systemRolePendings.revertKeep = function (userAccessRequestId, systemRoleId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRolePending/Keep/Revert',
                          {
                              SystemRoleID: systemRoleId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.systemRolePendings.removeConflict = function (userAccessRequestId, systemRoleId) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRole/RemoveConflict',
                          {
                              SystemRoleID: systemRoleId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.systemRolePendings.addAuthorizationExceptionForConflict = function (userAccessRequestId, conflicts,
                                                                               justification, expirationDate) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRole/Exception/Authorize/ForConflict',
                          {
                              Conflicts: conflicts,
                              Justification: justification,
                              ExpirationDate: expirationDate
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.systemRolePendings.addAuthorizationExceptionForSupervisor = function (userAccessRequestId, systemRoleId,
                                                                                  justification, expirationDate) {
        return $http.post(baseUrlRequestId(userAccessRequestId) + '/SystemRole/Exception/Authorize/ForSupervisor',
                          {
                              SystemRoleID: systemRoleId,
                              Justification: justification,
                              ExpirationDate: expirationDate
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
